import { Box } from '@chakra-ui/react';

import { TextBold, TextRegular } from 'UiKit/typography';
import { reportColumnTargetText } from 'Const/report/text';

import styles from './styles.module.css';

const ColumnTarget = ({ achievement, target }) => {
  const targetNumber = Number(target?.replace('%', '').replace(/\./g, '').replace(',', '.')) || 0;
  const isAchieved = targetNumber >= 100;
  return (
    <Box className={styles['column__target-container']}>
      <TextRegular className={styles['column__target-achievement']}>{achievement}</TextRegular>
      <TextBold className={styles['column__target-percentage']}>
        <span className={isAchieved ? styles['column__target--achieved'] : styles['column__target--not-achieved']}>{target}</span>{' '}
        {reportColumnTargetText?.targetLabel}
      </TextBold>
    </Box>
  );
};

export default ColumnTarget;
